/// <reference path="../../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export abstract class BaseWorkflowBlock implements IWorkflowBlock {

        private _logType: string = "BaseWorkflowBlock";

        public id: string;
        public componentId: string;
        public type: number;
        public isQuickLinkable: boolean;
        public workflowService: services.WorkflowService;

        public typeName: string;
        public label: string;
        public description: string;
        public isInitialBlock: boolean;

        public toBlocks: IWorkflowBlock[];
        public toBlockIds: string[];
        public statusCodeId: string;
        public processActionId: string;
        public insideExpandedProcessAction: boolean;

        public blockWidth: number;
        public blockHeight: number;
        public toolbarWidth: number;
        public toolbarHeight: number;

        public svgUrl: string;
        public svgWidth: number;
        public svgHeight: number;
        public svgScale: number;
        public svgToolbarScale: number;
        public svgHorizontalOffset: number;

        public svgAttributes: any;

        protected deleteImageElement: Snap.Element;
        protected settingsImageElement: Snap.Element;
        protected drawingInstance: models.WorkflowDrawingInstance;

        private blockAttributes: any;
        private outputType: string;

        public svgElement: Snap.Element;
        public standardLabel: Snap.Element;
        
        constructor(id: string, theType: number, label: string) {
            this.id = id;
            this.type = theType;
            this.typeName = WorkflowBlockManager.getWorkflowBlockNameByType(this.type);
            this.label = label;
            this.isQuickLinkable = false;

            this.blockWidth = 150;
            this.blockHeight = 150;

            this.toolbarWidth = 100;
            this.toolbarHeight = 75;

            this.svgHorizontalOffset = 0;

            this.blockAttributes = { opacity: 0};
            this.toBlocks = [];
        }

        protected drawEntireBlock(paper: Snap.Paper, coordinate: models.Coordinate): Snap.Element {
            // 10 px on each side is left for drop zones in between blocks
            var entireBlock = paper.rect(coordinate.x * this.blockWidth + 10, coordinate.y * this.blockHeight + 10, this.blockWidth - 20, this.blockHeight - 20);
            entireBlock.attr(this.blockAttributes)
            return entireBlock;
        }

        protected drawOptions(paper: Snap.Paper, coordinate: models.Coordinate) : void {
            var self = this;
            var iconWidth = this.getIconWidth();

            var deleteCoordinate = this.getDeleteCoordinate(coordinate);
            this.deleteImageElement = paper.image("./Images/Delete.svg", deleteCoordinate.x, deleteCoordinate.y, iconWidth, iconWidth);
            this.deleteImageElement.attr({ "data-class": "optionsImage", "data-id": "delete" });
            this.deleteImageElement.click((evt) => {
                self.delete();
            });

            var settingsCoordinate = this.getSettingsCoordinate(coordinate); 
            this.settingsImageElement = paper.image("./Images/Cog.svg", settingsCoordinate.x, settingsCoordinate.y, iconWidth, iconWidth);
            this.settingsImageElement.attr({ "data-class": "optionsImage", "data-id": "settings" });
            this.settingsImageElement.click((evt) => {
                self.drawingInstance.configureWorkflowBlock(self);
            });

            this.hideOptions();
        }

        private getSvgScaledWidth(): number {
            return this.svgWidth * this.svgScale;
        }

        private getSvgScaledHeight(): number{
            return this.svgHeight * this.svgScale;
        }

        private getSvgToolbarScaledWidth(): number {
            return this.svgWidth * this.svgToolbarScale;
        }

        private getSvgToolbarScaledHeight(): number {
            return this.svgHeight * this.svgToolbarScale;
        }

        private getXPadding() : number {
            return (this.blockWidth - this.getSvgScaledWidth()) / 2;
        }

        private getYPadding(): number {
            return (this.blockHeight - this.getSvgScaledHeight()) / 2;
        }

        private getCenterPoint(gridCoordinate: models.Coordinate): Coordinate {
            var xOffset = (gridCoordinate.x * this.blockWidth);
            var yOffset = (gridCoordinate.y * this.blockHeight);
            return new Coordinate(this.blockWidth / 2 + xOffset, this.blockHeight / 2 + yOffset);
        }

        public setQuickLinkInfo(componentId: string, workflowService: services.WorkflowService) {
            this.componentId = componentId;
            this.workflowService = workflowService;
        }

        public getBottomPadding(): number {
            return this.getYPadding() - 20;
        }

        public getTopPadding(): number {
            return this.getYPadding();
        }

        public getLeftPadding(): number {
            return this.getXPadding() + this.svgHorizontalOffset;
        }

        public getRightPadding(): number {
            return this.getXPadding() - this.svgHorizontalOffset;
        }

        public draw(paper: Snap.Paper, coordinate: models.Coordinate): Snap.Element {
            var xOffset = (coordinate.x * this.blockWidth) + this.getXPadding() + this.svgHorizontalOffset;
            var yOffset = (coordinate.y * this.blockHeight) + this.getYPadding();

            var entireBlock = this.drawEntireBlock(paper, coordinate);
            var centerPoint = this.getCenterPoint(coordinate);

            this.standardLabel = paper.text(centerPoint.x, yOffset + this.getSvgScaledHeight() + 14, this.label);
            this.standardLabel.attr({ class: "workflow-text" });

            if (this.isQuickLinkable) {
                // Add hover to label to make it look like a link
                this.standardLabel.hover(
                    () => {
                        if (this.componentId) {
                            this.standardLabel.addClass("link-hover");
                        }
                    },
                    () => {
                        if (this.componentId) {
                            this.standardLabel.removeClass("link-hover");
                        }
                    });

                // Add click handler to quick link
                this.standardLabel.click(() => {
                    if (this.componentId) {
                        this.workflowService.quickLink(this);
                    }
                });
            }

            this.svgElement = paper.image(this.svgUrl, xOffset, yOffset, this.getSvgScaledWidth(), this.getSvgScaledHeight());
            this.svgElement.attr(this.svgAttributes);

            this.drawOptions(paper, coordinate);

            var generatePdfGroup = paper.group(
                entireBlock,
                this.svgElement,
                this.standardLabel,
                this.deleteImageElement, this.settingsImageElement);

            return generatePdfGroup;
        }

        public drawForToolbar(paper: Snap.Paper): Snap.Element {
            var width = this.getSvgToolbarScaledWidth();
            var height = this.getSvgToolbarScaledHeight();

            var horizontalOffset = this.svgHorizontalOffset * (this.svgToolbarScale / this.svgScale);

            var verticalPadding = (this.toolbarHeight - height) / 2;
            var horizontalPadding = (this.toolbarWidth - width) / 2 + horizontalOffset;

            this.svgElement = paper.image(this.svgUrl, horizontalPadding, verticalPadding, width, height);
            this.svgElement.attr(this.svgAttributes);

            var label = paper.text(this.toolbarWidth / 2, height + verticalPadding + 13, this.label);
            label.attr({ class: "toolbar-text" });

            var generatePdfGroup = paper.group(this.svgElement, label);
            return generatePdfGroup;
        }

        public getDeleteCoordinate(coordinate: models.Coordinate): Coordinate {
            var iconWidth = this.getIconWidth();

            var xOffset = (coordinate.x * this.blockWidth) + this.getXPadding();
            var yOffset = (coordinate.y * this.blockHeight) + this.getYPadding();

            var x = xOffset + this.getSvgScaledWidth() - iconWidth / 2;
            var y = yOffset - (iconWidth / 2);

            return new Coordinate(x, y);
        }

        public getSettingsCoordinate(coordinate: models.Coordinate): Coordinate {
            var iconWidth = this.getIconWidth();

            var xOffset = (coordinate.x * this.blockWidth) + this.getXPadding();
            var yOffset = (coordinate.y * this.blockHeight) + this.getYPadding();

            var x = xOffset - iconWidth / 2;
            var y = yOffset - (iconWidth / 2);

            return new Coordinate(x, y);
        }

        public hoverStart(): void {
            this.showOptions();
        }

        public hoverEnd(): void {
            this.hideOptions();
        }

        protected updateDrawingBasedOnLabelLengths(): void {
            this.trimTextToSize(this.standardLabel, this.blockWidth);
        }

        public entireWorkflowDrawComplete() {
            // override in subclass is anything else needs to happen after the workflow draw is complete
            this.updateDrawingBasedOnLabelLengths();
        }

        public entireWorkflowDrawComplete2() {
        }

        protected hideOptions(): void {
            this.hideElement(this.deleteImageElement);
            this.hideElement(this.settingsImageElement);
        }

        protected showOptions(): void {
            if (this.deleteImageElement && this.canBeDeleted()) {
                this.showElement(this.deleteImageElement);
            }
            if (this.type !== Wars.Domain.Model.Codes.Enums.BlockType.StartProcessAction) {
                this.showElement(this.settingsImageElement);
            }
        }

        private hideElement(element: Snap.Element): void {
            if (element) {
                element.stop();
                element.attr({ opacity: '0' });
            }
        }

        private showElement(element: Snap.Element, opacity?: number): void {
            if (element) element.animate({ opacity: opacity ? opacity: 1 }, 300);
        }

        

        abstract getOutputType(): Wars.Domain.Model.Codes.Enums.BlockOutputType;

        

        protected getIconWidth(): number {
            return 40;
        }

        public canConnectToWorkflowBlockType(type: number): boolean {
            return models.WorkflowBlockManager.getValidToBlockTypes(this.type).indexOf(type) !== -1;
        }

        public getFromWorkflowBlocks(): Array<models.IWorkflowBlock> {
            var list: Array<models.IWorkflowBlock> = [];
            var allBlocks = Enumerable.from(this.drawingInstance.blockLocations).select(i => i.workflowBlock).toArray();
            for (var i = 0; i < allBlocks.length; i++) {
                var currentBlock = allBlocks[i];
                var isAFromBlock = Enumerable.from(currentBlock.toBlocks).any(i => i && i.id === this.id);
                if (isAFromBlock) list.push(currentBlock);
            }
            return list;
        }

        public canBeDeleted(): boolean {
            if (this.drawingInstance.isReadonly) return false;
            
            // Cannot remove the initial state
            if (this.drawingInstance.blockLocations[0].workflowBlock.id === this.id) return false;

            var allFroms = this.getFromWorkflowBlocks();
            // cannot delete anything that has more than one block pointing to it.
            if (allFroms.length > 1) return;

            var fromBlock = allFroms[0];

            var allTos = Enumerable.from(this.toBlocks).where(i => i.type !== Wars.Domain.Model.Codes.Enums.BlockType.DropZone).toArray();

            // Ensure each block before can connect to the block afterwards
            for (var toIndex = 0; toIndex < allTos.length; toIndex++) {
                var currentToBlock = allTos[toIndex];
                if (!fromBlock.canConnectToWorkflowBlockType(currentToBlock.type)) {
                    // Cannot delete this workflow item return false
                    return false;
                }
            }

            // Ensure the single output blocks do not get multiple blocks
            if (fromBlock.getOutputType() === Wars.Domain.Model.Codes.Enums.BlockOutputType.Single && allTos.length > 1) return false;
            if (fromBlock.getOutputType() === Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo && allTos.length > 1) return false;

            return true;
        }

        public delete(): void {
            if (this.canBeDeleted()) {
                var confirmation = confirm("Are you sure you want to delete this workflow block?");
                if (confirmation) {
                    this.drawingInstance.removeWorkflowBlockFromWorkflow(this);
                }
            } else {
                alert("Sorry this workflow block cannot be deleted because it would invalidate the workflow.");
            }
        }

        public setDrawingInstance(drawingInstance: models.WorkflowDrawingInstance): void {
            this.drawingInstance = drawingInstance;
        }

        public addTitleToGroup(group: any): void {
            if (this.label == undefined || this.label == '') return;
            if (this.type == Wars.Domain.Model.Codes.Enums.BlockType.DropZone || this.type == Wars.Domain.Model.Codes.Enums.BlockType.Goto) return;
            var title = <Snap.Element>Snap.parse('<title>' + this.label + '</title>');
            group.append(title);
        }

        protected trimTextToSize(labelElement: Snap.Element, width: number) : void {
            // using set timeout because the text element has to be rendered for getBBox to work and the browser doesn't always render right away when rending a lot of SVG 
            var timeoutMethod = () => {
                var textWidth = labelElement.getBBox().width;
                services.WarsLogger.logDebug('Text Width: ' + textWidth, this._logType);
                var text = labelElement.node.textContent;
                var padding = 2;

                while (textWidth > (width - 2 * padding) && text.length > 0) {
                    text = text.slice(0, -1);
                    labelElement.attr({ text: text + '...' });
                    textWidth = labelElement.getBBox().width;
                } 
            };

            setTimeout(timeoutMethod, 1);
        }

        // Was using this to show the entire label in a custom designed callout.
        protected enlargeRectangleSizeToFitText(textElement: Snap.Element, rectangle: Snap.Element): void {
            // using set timeout because the text element has to be rendered for getBBox to work and the browser doesn't always render right away when rending a lot of SVG 
            var timeoutMethod = () => {
                var boundingBox = textElement.getBBox();
                var textWidth = boundingBox.width + 5;
                var textHeight = boundingBox.height;
                var x = parseInt(rectangle.attr('x')) - 0.5 * textWidth;
                var y = parseInt(rectangle.attr('y')) - 0.5 * textHeight - 5;
                rectangle.attr({ x: x, y: y, width: textWidth, height: textHeight});
            }
            setTimeout(timeoutMethod, 1);
        }
    }
}